import { useGetConsultationsStatisticsQuery } from '@/core/services/statistics'

import ConsultationStatistic from '../components/ConsultationStatistic'

export default function ConsultationStatisticContainer() {
  const { data } = useGetConsultationsStatisticsQuery()

  return <ConsultationStatistic total={data?.total ?? 0} />
}
